import sample_1 from './olympBodyFit.jpg';

export const olympBodyFitImpressions = {
    sample_1,
};
